import { useSelector } from 'react-redux';

export const usePreviousPath = () => {
  return useSelector((state: any) => state.routes.previousPath);
};
